import { MagnifyingGlass, SlidersHorizontal, X } from "@phosphor-icons/react";
import { tagLabel, text } from "../i18n.js";
import type { Locale, SupportStatus } from "../types.js";

export type CatalogSort = "featured" | "newest" | "updated";

export interface CatalogFilterState {
  readonly query: string;
  readonly tag: string;
  readonly status: "" | SupportStatus;
  readonly featured: boolean;
  readonly sort: CatalogSort;
}

interface CatalogToolbarProps {
  readonly locale: Locale;
  readonly filters: CatalogFilterState;
  readonly tags: readonly string[];
  readonly onChange: (next: CatalogFilterState) => void;
}

export function CatalogToolbar({ locale, filters, tags, onChange }: CatalogToolbarProps) {
  const t = text(locale);
  const active = Boolean(filters.query || filters.tag || filters.status || filters.featured || filters.sort !== "featured");
  return (
    <div className="catalog-tools">
      <div className="search-field">
        <MagnifyingGlass aria-hidden="true" weight="bold" />
        <label htmlFor="theme-search">{t.searchLabel}</label>
        <input
          id="theme-search"
          type="search"
          autoComplete="off"
          value={filters.query}
          placeholder={t.searchPlaceholder}
          onChange={(event) => onChange({ ...filters, query: event.currentTarget.value })}
        />
      </div>
      <div className="filter-heading"><SlidersHorizontal aria-hidden="true" weight="bold" /><strong>{t.filters}</strong></div>
      <div className="filter-controls">
        <label><span>{locale === "zh-CN" ? "标签" : "Tag"}</span>
          <select value={filters.tag} onChange={(event) => onChange({ ...filters, tag: event.currentTarget.value })}>
            <option value="">{t.allTags}</option>
            {tags.map((tag) => <option key={tag} value={tag}>{tagLabel(locale, tag)}</option>)}
          </select>
        </label>
        <label><span>{t.compatibility}</span>
          <select value={filters.status} onChange={(event) => onChange({ ...filters, status: event.currentTarget.value as CatalogFilterState["status"] })}>
            <option value="">{t.allStatuses}</option>
            {(Object.keys(t.status) as SupportStatus[]).map((status) => <option key={status} value={status}>{t.status[status]}</option>)}
          </select>
        </label>
        <label><span>{t.sortLabel}</span>
          <select value={filters.sort} onChange={(event) => onChange({ ...filters, sort: event.currentTarget.value as CatalogSort })}>
            <option value="featured">{t.sortFeatured}</option>
            <option value="newest">{t.sortNewest}</option>
            <option value="updated">{t.sortUpdated}</option>
          </select>
        </label>
        <label className="check-control">
          <input type="checkbox" checked={filters.featured} onChange={(event) => onChange({ ...filters, featured: event.currentTarget.checked })} />
          <span>{t.featuredOnly}</span>
        </label>
        <button
          className="clear-button"
          type="button"
          disabled={!active}
          onClick={() => onChange({ query: "", tag: "", status: "", featured: false, sort: "featured" })}
        ><X aria-hidden="true" />{t.clearFilters}</button>
      </div>
    </div>
  );
}
